import { readSessionScoped, removeSessionScoped, writeSessionScoped } from "@/platform/browser/session-store"

export const SIGNUP_STATE_KEY = "nelo_signup_state"

export const readSignupState = (): string | undefined => readSessionScoped(SIGNUP_STATE_KEY)

export const writeSignupState = (value: string): void => writeSessionScoped(SIGNUP_STATE_KEY, value)

export const clearSignupState = (): void => removeSessionScoped(SIGNUP_STATE_KEY)
